export enum LotStatus {
    Closed = 'closed',
    Live = 'live',
    Locked = 'locked',
    Passed = 'passed',
    Pending = 'pending',
    Sold = 'sold',
    Upcoming = 'upcoming',
    Won = 'won',
}
